<div container>
  <ui-error [state]="loadState"></ui-error>

  <form [formGroup]="form" *visible="loadState.isCompleted" autocomplete="off">
    <div class="table-responsive mat-elevation-z2" *ngIf="!appLayout.isMobile">
      <table mat-table [dataSource]="dataSource" formArrayName="degrees" [ui-column-width]="[200, 250, 100, 72]">
        <ng-container matColumnDef="degree-type">
          <th mat-header-cell *matHeaderCellDef i18n>סוג התואר</th>
          <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
            <mat-form-field>
              <mat-select formControlName="degreeTypeId" required>
                <mat-option [value]="0" i18n>
                  {gender, select, male {בחר} female {בחרי}}
                  סוג תואר
                </mat-option>
                <mat-option *ngFor="let type of degreeTypes" [value]="type.id">{{ type?.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="degree-track-name">
          <th mat-header-cell *matHeaderCellDef i18n>חוג</th>
          <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
            <mat-form-field>
              <mat-select formControlName="degreeTrackId" required>
                <mat-option [value]="0" i18n>
                  {gender, select, male {בחר} female {בחרי}}
                  חוג
                </mat-option>
                <mat-option *ngFor="let track of degreeTracks" [value]="track.id">{{ track?.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="average">
          <th mat-header-cell *matHeaderCellDef i18n>ממוצע</th>
          <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
            <mat-form-field floatLabel="never">
              <input
                type="number"
                matInput
                formControlName="average"
                placeholder="ממוצע"
                i18n-placeholder
                (click)="addEmptyRow()"
                required
              />
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>

          <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
            <button
              mat-icon-button
              type="button"
              [matTooltip]="deleteButtonTooltip.text"
              (click)="removeDegree(index)"
              [disabled]="!canRemoveDegree(row)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
      </table>
    </div>

    <div *ngIf="appLayout.isMobile" formArrayName="degrees">
      <ng-template #degreeEditor let-row let-i="index">
        <registration-entry-editor-shell
          [formGroupName]="i"
          [mode]="rowsEditor.isAddingRow(row) ? 'add' : 'edit'"
          [addTitle]="addDegreeTitle.text"
          [editTitle]="editDegreeTitle.text"
          [invalid]="rowsEditor.invalid"
          [invalidBody]="degreeInvalidBody.text"
          [cancelTooltip]="cancelTooltip.text"
          (cancel)="rowsEditor.cancel(row)"
          (save)="rowsEditor.save(row)"
        >
          <mat-form-field appearance="fill">
            <mat-label i18n>סוג התואר</mat-label>
            <mat-select formControlName="degreeTypeId" required>
              <mat-option [value]="0" i18n>
                {gender, select, male {בחר} female {בחרי}}
                סוג תואר
              </mat-option>
              <mat-option *ngFor="let type of degreeTypes" [value]="type.id">{{ type?.name }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label i18n>חוג</mat-label>
            <mat-select formControlName="degreeTrackId" required>
              <mat-option [value]="0" i18n>
                {gender, select, male {בחר} female {בחרי}}
                חוג
              </mat-option>
              <mat-option *ngFor="let track of degreeTracks" [value]="track.id">{{ track?.name }}</mat-option>
            </mat-select>
            <mat-error *ngIf="row | hasError: 'degreeTrackId'" i18n>שדה חובה</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label i18n>ממוצע</mat-label>
            <input type="number" matInput formControlName="average" required />
            <mat-error *ngIf="row | hasError: 'average'" i18n>שדה חובה</mat-error>
            <mat-error *ngIf="row | hasError: 'average' : 'min'" i18n>נא הזן ממוצע גדול שווה ל-0</mat-error>
            <mat-error *ngIf="row | hasError: 'average' : 'max'" i18n>נא הזן ממוצע קטן שווה ל-100</mat-error>
          </mat-form-field>
        </registration-entry-editor-shell>
      </ng-template>

      <ng-template #degreeCard let-row let-i="index">
        <registration-entry-card
          [title]="rowDegreeTrackName(row) || rowDegreeTypeName(row)"
          [meta]="rowDegreeTrackName(row) && rowDegreeTypeName(row) ? rowDegreeTypeName(row) : null"
          [editTooltip]="editTooltip.text"
          [deleteTooltip]="deleteButtonTooltip.text"
          [canDelete]="canRemoveDegree(row)"
          (edit)="rowsEditor.startEdit(row)"
          (delete)="removeDegree(i)"
        >
          <div footerStart *ngIf="row.value.average != null" class="registration-entry-card__meta">
            <span i18n>ממוצע</span> {{ row.value.average }}
          </div>
        </registration-entry-card>
      </ng-template>

      <registration-entry-list
        [rows]="rows"
        [editor]="rowsEditor"
        [addLabel]="addDegreeTitle.text"
        [editorTemplate]="degreeEditor"
        [cardTemplate]="degreeCard"
      >
      </registration-entry-list>
    </div>

    <ui-alert type="warning" *visible="showError && errorList.length > 0">
      <div ui-header i18n>לא ניתן לשמור מכיון שאחד או יותר מהפרטים שגויים או חסרים</div>

      <ul ui-body>
        <ng-container *ngFor="let error of errorList">
          <li *ngIf="error == 'degreeTrackId-required' || error == 'degreeTrackId-min'" i18n>נא הזן חוג</li>
          <li *ngIf="error == 'average-required'" i18n>נא הזן ממוצע</li>
          <li *ngIf="error == 'average-min'" i18n>נא הזן ממוצע גדול שווה ל-0</li>
          <li *ngIf="error == 'average-max'" i18n>נא הזן ממוצע קטן שווה ל-100</li>
        </ng-container>
      </ul>
    </ui-alert>

    <ui-error [state]="saveState"></ui-error>

    <ui-progress-button color="primary" [state]="saveState" (progress)="saveAsync()" i18n>
      {saveState.value, select, inProcess {שומר נתונים} other {שמור והמשך}}
    </ui-progress-button>
  </form>
</div>

<term #deleteButtonTooltip i18n>
  {gender, select, male {מחק} female {מחקי}}
  שורה
</term>

<term #editTooltip i18n>
  {gender, select, male {ערוך} female {ערכי}}
</term>

<term #cancelTooltip i18n>ביטול</term>

<term #addDegreeTitle i18n>הוספת תואר</term>

<term #editDegreeTitle i18n>עריכת תואר</term>

<term #degreeInvalidBody i18n>חובה לבחור סוג תואר, חוג וממוצע</term>
